import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-step-smart-import',
  templateUrl: './step-smart-import.component.html',
  styleUrls: ['./step-smart-import.component.scss']
})
export class StepSmartImportComponent {

  @Output() back = new EventEmitter<void>();

}
